import { basePath } from 'const';
import { SIMPLIFIED_FLOW_STEPS } from 'steps';

export const config = {
  id: SIMPLIFIED_FLOW_STEPS.FOUR,
  idx: 4,
  next: () => SIMPLIFIED_FLOW_STEPS.FOUR,
  slug: `${basePath}/${SIMPLIFIED_FLOW_STEPS.FOUR}`,
};
